import { render, staticRenderFns } from "./paragraphList.vue?vue&type=template&id=1a1bafc2&scoped=true"
import script from "./paragraphList.vue?vue&type=script&lang=js"
export * from "./paragraphList.vue?vue&type=script&lang=js"
import style0 from "./paragraphList.vue?vue&type=style&index=0&id=1a1bafc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1bafc2",
  null
  
)

export default component.exports